import { SoccerGoalAttribute } from '@collector/sportsapi-client-legacy'

import { DetailBaseConfigAttributes } from '../../../../composables/useSportOptions'

export const techniqueOfShotDetailsAttributes: DetailBaseConfigAttributes<SoccerGoalAttribute>['attributes'] =
  [
    {
      attributeId: SoccerGoalAttribute.LeftFoot,
      isActive: (attributes) => {
        const validAttributes = [
          SoccerGoalAttribute.Normal,
          SoccerGoalAttribute.FirstTouch,
          SoccerGoalAttribute.Volley,
          SoccerGoalAttribute.DirectFreeKick,
          SoccerGoalAttribute.BicycleKick,
        ]

        return attributes.some((attribute) =>
          validAttributes.includes(attribute),
        )
      },
    },
    {
      attributeId: SoccerGoalAttribute.RightFoot,
      isActive: (attributes) => {
        const validAttributes = [
          SoccerGoalAttribute.Normal,
          SoccerGoalAttribute.FirstTouch,
          SoccerGoalAttribute.Volley,
          SoccerGoalAttribute.DirectFreeKick,
          SoccerGoalAttribute.BicycleKick,
        ]

        return attributes.some((attribute) =>
          validAttributes.includes(attribute),
        )
      },
    },
    {
      attributeId: SoccerGoalAttribute.PowerShot,
      isActive: (attributes) => {
        const validAttributes = [
          SoccerGoalAttribute.Normal,
          SoccerGoalAttribute.FirstTouch,
          SoccerGoalAttribute.Volley,
          SoccerGoalAttribute.DirectFreeKick,
        ]

        return attributes.some((attribute) =>
          validAttributes.includes(attribute),
        )
      },
    },
    {
      attributeId: SoccerGoalAttribute.Chip,
      isActive: (attributes) => {
        const validAttributes = [SoccerGoalAttribute.Normal]

        return attributes.some((attribute) =>
          validAttributes.includes(attribute),
        )
      },
    },
  ]
